import { WSElement, WSSectionToolbar } from "@wingspanhq/fe-component-library";
import {
  PayeeEngagement,
  PayeeRow,
  WorkLog
} from "@wingspanhq/wingspan-api-sdk";

import { useHistory } from "react-router-dom";
import { DataView } from "../../../shared/components/DataView";
import { selectorSearchRowName } from "../../../shared/selectors/selectorSearchRowName";
import { buildPayeeDetailsPath } from "../../Payees/utils";
import { useQueryWorkLogConvertedResource } from "../hooks/useQueryWorkLogConvertedResource";
import { selectorWorkLogWorkerNoun } from "../selectors/selectorWorkLogWorkerNoun";
import { getWorkLogPayerStatusCellProps } from "../utils/getWorkLogPayerStatusCellProps";
import styles from "./WorkLogAssignmentInfo.module.scss";

type Props = {
  shimmer?: boolean;
  workLog?: WorkLog;
  payeeRow?: PayeeRow;
  payerPayeeEngagement?: PayeeEngagement;
  /** Resolved by the route, which already reads the work log's payroll run. */
  isApprovalExpired?: boolean;
};

export const WorkLogAssignmentInfoPayerView: React.FC<Props> = props => {
  const history = useHistory();

  // TODO(v3): `invoiceId` renamed to `convertedResourceId` on v3 WorkLog.
  const { payable, payStatement } = useQueryWorkLogConvertedResource(
    props.workLog
  );

  const statusCellProps = props.workLog
    ? getWorkLogPayerStatusCellProps({
        workLog: props.workLog,
        payable,
        payStatement,
        isApprovalExpired: props.isApprovalExpired,
        engagementType: props.payerPayeeEngagement?.engagementType
      })
    : undefined;

  const payeeName = props.payeeRow
    ? selectorSearchRowName(props.payeeRow)
    : undefined;
  const payeeId = props.payeeRow?.id;

  return (
    <WSElement>
      <WSSectionToolbar title="Engagement information" />
      <DataView
        shimmer={props.shimmer}
        data={[
          {
            label: "Engagement name",
            value: props.payerPayeeEngagement?.engagementName
          },
          {
            label: "Status",
            secondaryText:
              statusCellProps?.text || statusCellProps?.secondaryText,
            secondaryTextColor: statusCellProps?.secondaryTextColor,
            pill: statusCellProps?.pill,
            hideValue: true
          },
          {
            label: `${selectorWorkLogWorkerNoun(
              props.payerPayeeEngagement?.engagementType
            )} name`,
            value: payeeName && payeeId ? "" : payeeName,
            action:
              payeeName && payeeId
                ? {
                    label: payeeName,
                    onClick: () => history.push(buildPayeeDetailsPath(payeeId)),
                    className: styles.entityLink
                  }
                : undefined
          }
        ]}
      />
    </WSElement>
  );
};
